var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5126 12.2344C8.23605 12.8849 6.6665 14.9657 6.6665 17.3333M10.5126 12.2344C13.1399 11.4838 18.7026 11.0007 19.7688 8.00984M10.5126 12.2344C10.5126 6.66663 15.9998 7.99996 15.9998 2.66663C18.729 2.66663 20.67 5.48111 19.7688 8.00984M19.7688 8.00984C21.9385 7.82356 23.3921 10.3179 22.246 12.1046M22.246 12.1046C21.881 12.6735 21.2814 13.1367 20.6665 13.492M22.246 12.1046C24.8556 12.7137 25.3332 15.0582 25.3332 17.3333",
    stroke: "#141B34",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 29.3333H22.6668L24.878 24.8786C25.6596 23.3038 26.6668 21.7481 26.6668 19.9316C26.6668 16.4672 21.3335 16.4672 21.3335 19.9316C21.3335 16.4672 16.0002 16.4672 16.0002 19.9316C16.0002 16.4672 10.6668 16.4672 10.6668 19.9316C10.6668 16.4672 5.3335 16.4672 5.3335 19.9316C5.3335 21.7481 6.3407 23.3038 7.12235 24.8786L9.3335 29.3333Z",
    stroke: "#141B34",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.504580c4bfc1ee4490cd092143ceb205.svg";
export { ForwardRef as ReactComponent };